import React, { useEffect, useState, useContext } from "react";

import { callApi } from "bodycodi/cmap/app/js/common.js";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";
import icon_bell from "bodycodi/cmap/app/svg/icon_bell.svg";
import useInterval from "bodycodi/cmap/app/components/common/useInterval";
import { api } from "bodycodi/cmap/app/js/api";

const MessageWrap = () => {
  const { dispatch } = useContext(DispatchContext);
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const [unreadCnt, setUnreadCnt] = useState(0);

  useEffect(() => {
    // 알림 클릭시 해당 target으로 이동, iOS
    window.addEventListener("message", ({ data }) => {
      if (typeof data === "string" && data.includes("notification")) {
        const objData = JSON.parse(data);
        if (objData?.name === "notification") {
          if (objData.isNavi && objData.target === "/community") {
            homeDispatch({ type: "CLICK_FOOTER", state: 2 });
          }
          setUnreadCnt(objData.notiCount);
        }
      }
    });

    window.addEventListener("targetPage", async (event: any) => {
      // 1: 스케줄, 2: 커뮤니티
      if (event.detail.data === 2) {
        homeDispatch({ type: "CLICK_FOOTER", state: 2 });
      }
    });

    return () => {
      window.removeEventListener("message", ({ data }) => {
        if (typeof data === "string" && data.includes("notification")) {
          const objData = JSON.parse(data);
          if (objData?.name === "notification") {
            if (objData.isNavi && objData.target === "/community") {
              homeDispatch({ type: "CLICK_FOOTER", state: 2 });
            }
            setUnreadCnt(objData.notiCount);
          }
        }
      });
      window.removeEventListener("targetPage", async (event: any) => {
        if (event.detail.data === 2) {
          homeDispatch({ type: "CLICK_FOOTER", state: 2 });
        }
      });
    };
  }, []);

  useEffect(() => {
    callApi("/cmap8010/viewUnreadTimeline", {}, "GET", false).then((res) => {
      setUnreadCnt(res.UnreadCntVO.mobileTimelineUnreadCnt);
    });
  }, []);

  useInterval(() => {
    const tokenData = window.localStorage.getItem("accessToken");
    if (tokenData) {
      api.defaults.headers.common["Authorization"] = `Bearer ${tokenData}`;
    }
    callApi("/cmap8010/viewUnreadTimeline", {}, "GET", false).then((res) => {
      setUnreadCnt(res.UnreadCntVO.mobileTimelineUnreadCnt);
    });
  }, 30000);

  const clickAlram = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ALRAM_POP", open: { alramPop: true } });
    setUnreadCnt(0);
  };

  return (
    <div className="alert-wrap" onClick={clickAlram}>
      {unreadCnt !== 0 && <div className="unread">{unreadCnt}</div>}
      <img src={icon_bell} />
    </div>
  );
};

export default MessageWrap;
